mutation homeNumberDelete($id: ID!) {
  homeNumberDelete(id: $id) {
    id
  }
}
